<template>
  <main>
    <!-- Start Banner -->
    <div class="banner solution">
      <div class="container custom">
        <div class="banner__content">
          <div class="banner__box">
            <div class="banner__box-item" data-aos="fade-up">
              <div class="item__title">Solutions</div>
              <div class="item__content">TimeBird provides a FinTech ecosystem which can be customized to customer’s own needs, proposes solutions to help customers effectively manage production and business activities, as well as provides consulting and training services, specialized in the field of fintech.</div>
            </div>
            <div class="banner__box-item" data-aos="fade" data-aos-delay="500">
              <div class="item__image">
                <img src="/assets/images/solution/solution-image.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner -->
    <!-- Start Solution -->
    <div class="solution" data-aos="fade">
      <div class="container-fluid">
        <swiper :options="solutionOption" class="solution__slide swiper__solution">
          <template v-for="(item, index) in listSolution">
            <swiper-slide :key="index" class="solution__slide-item">
              <div class="item__icon">
                <img :src="`/assets/images/solution/${item.icon}.png`" alt="">
              </div>
              <div class="item__title">{{ item.title }}</div>
              <div class="item__content">{{ item.text }}</div>
            </swiper-slide>
          </template>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!-- End Solution -->
  </main>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      listSolution: [
        { icon: 'crypto', title: 'Crypto exchange', text: 'By developing the Cloud Exchange Network System (CEN), TimeBird’s reduced the time for building a crypto exchange compared to usual. Moreover, TimeBird’s applied the multi-tier architecture system and eKYC on CEN. It keeps the crypto exchange running stablely, accurately, transparently and fits to diversified projects.' },
        { icon: 'p2p-trading', title: 'P2P trading platform', text: 'Working and coperating for several trading plaforms for many years, the development team comprehends how to build P2P plaform well that brings the best experience for both users and operators. Anyone can easily trade and get liquidity quickly and reliably.' },
        { icon: 'crypto-wallet', title: 'Crypto wallet', text: 'TimeBird’s offered various models of storing digital assets such as cold wallet, HD wallet which strictly comply with the rules of asset assurance, security and anonymity of users. Beside, TimeBird can customize and list crypto currencies as many as customer’s needs.' },
        { icon: 'smart-contract', title: 'Smart contract', text: 'Delivered hundreds of smart contracts on various blockchain platforms, the development team is confident to help customers create smart contracts that comply with the highest blockchain standards.' },
        { icon: 'cryptocurrency', title: 'Cryptocurrency Development', text: 'Depending on customer’s need, TimeBird can create a native coin/token or a new coin/token on the existing blockchain which could be deployed on any blockchain with the reasonable cost.' },
        { icon: 'tokenization', title: 'Tokenization', text: 'When IT technologies makes the world becoming more and more open and transparent, the valuable information and personal data become the target of black-hat hackers. TimeBird’s tokenization solutions enable customers to safely store valuable information while preserve its business utility.' },
        { icon: 'nft', title: 'NFT Development', text: 'From customer’s idea, TimeBird can turn it into an highly customizable NFT or NFT platform applied the leading blockchain technologies. The development team also has a lot of experience to optimize product on many different blockchains. ' },
        { icon: 'nft-market', title: 'NFT Market', text: 'With the experience of building and operating many exchanges, TimeBird provides the service of building a high-speed and safe NFT trading market. Users will experience useful utilities such as real-time transaction history, visual analytic reports.' },
        { icon: 'blockchain', title: 'Blockchain Consulting', text: 'Not only having rich experience in the financial sector, TimeBird experts also offer solutions to apply blockchain in other life activities such as retail and insurance sector. ' },
        { icon: 'ai-consulting', title: 'AI Consulting', text: 'Based on the strengths in Computer Vision, TimeBird is helping customer to improve security level in financial transactions. With the other sector, The AI experts will support customer to identify AI use cases and provide end-to-end AI Solutions to drive effective business results.' },
        { icon: 'portal-api', title: 'Portal API Services', text: 'Understanding the software development process, TimeBird provides an API portal for a number of shared products that contribute to save time and money for other development teams. Currently, TimeBird’s Portal API offers two services named eKYC and Blockchain Service which the other software development teams can easily experiment and connect to.' },
        { icon: 'sso-service', title: 'SSO Service', text: 'For customers who develop a number of applications using the same customer database, TimeBird provides a SSO service. It helps the operator to easily manage the users’ login or improve user experience.' },
        { icon: 'digital-transformation', title: 'Digital transformation', text: 'Implementing digital transformation helps enterprises save resources and increase intrinsic values. TimeBird’s experts is ready to give advice and discuss with customers to find a way to integrate digital technology into business operations.' },
        { icon: 'in-dept-technical', title: 'In-dept technical training', text: 'The demand for high-quality IT resources brings valued opportunities for TimeBird in the in-depth technical training field. Full-stack development, security testing and performance testing are the major courses of TimeBird Academy. Customers can enroll in TimeBird’s existing programs or request to make a tailored programs to meet their technical needs.' },
      ],
      solutionOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        initialSlide: 0,
        centeredSlides: true,
        breakpoints: {
          576: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
          1680: {
            slidesPerView: 4,
            initialSlide: 1,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    }
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>